<template>
    <div id="page-wrapper">
      <div class="row">
        <div class="col-lg-12">
          <h1 class="page-header">
            <i class="fa fa-dashboard fa-fw"></i> Rotinas
          </h1>
          <h3>Rotinas será a pagina de dashboard das rotinas executadas por empresas credenciadas em alguma atividade, onde vai ter um painel com os dados relevantes referente as rotinas.
             Uma rotina estabele documentos necessarios para sua execução</h3>
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- /#page-wrapper -->
  </template>
  
  <script>
  export default {
    name: "RoutinesDashBoard",
  };
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  </style>
  


// WEBPACK FOOTER //
// src/components/pages/RoutinesDashBoard.vue